<script setup lang="ts">
import VideoJSPlayer from '~/components/partials/VideoJSPlayer.vue';
import Link from '~/components/partials/Link.vue';
import { getMuxThumbnail } from '~/utils/GetMuxThumbnail';

import type { NavigationTeaserFragment } from '#gql';

const props = defineProps<{
  navigationTeaser: NavigationTeaserFragment;
}>();

const getMediaType = (mimeType: string) => {
  if (mimeType.includes('image')) {
    return 'image';
  }
  return 'video';
};

const mediaType = computed(() =>
  getMediaType(props.navigationTeaser.image?.mimeType ?? ''),
);

const getThumbnail = (muxPlaybackId: string) => {
  return getMuxThumbnail(muxPlaybackId);
};
</script>

<template>
  <div class="menu-teaser">
    <img
      v-if="mediaType === 'image'"
      class="image"
      :src="navigationTeaser?.image?.url"
    />
    <VideoJSPlayer
      v-if="mediaType === 'video'"
      class="video"
      :poster="
        getThumbnail(navigationTeaser?.image?.video?.muxPlaybackId ?? '')
      "
      :options="{
        autoplay: true,
        muted: true,
        controls: false,
        loop: true,
        auto: true,
        fill: true,
        responsive: true,
        playsinline: true,

        sources: [
          {
            src: navigationTeaser?.image?.video?.streamingUrl,
            type: 'application/x-mpegURL',
          },
        ],
      }"
    />
    <Link
      class="link-container text-sm"
      v-if="navigationTeaser?.link"
      :link="navigationTeaser?.link"
    >
      <img class="icon" src="/icons/arrow-right.svg" />
    </Link>
  </div>
</template>

<style lang="scss" scoped>
.menu-teaser {
  aspect-ratio: 4/3;
  border-radius: var(--base-border-radius-small);
  overflow: hidden;
  position: relative;
  background-color: var(--base-color-background);
}

.menu-teaser > .image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-teaser > .video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-teaser > .link-container {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  background: var(--base-color-foreground);
  color: white;
  padding: 0.5rem 1.5rem;
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  border-radius: var(--base-border-radius-small);
  text-decoration: none;
}

.menu-teaser > .link-container > .icon {
  margin-block: auto;
  width: 1.5rem;
}
</style>
